import { Chip, styled } from '@zeiss/beyond-online-react';
import { useTranslation } from 'react-i18next';

import { getUserInformation } from './';
import { SearchUsersResponse } from 'src/types/rest/managementPortalApi';

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-responsive-s, 16px) var(--spacing-s, 16px);
  align-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
`;

type UserSearchResultItemsProps = {
  selectedUsers: SearchUsersResponse[];
} & (
  | {
      disabled: false;
      onDeselect: (id: SearchUsersResponse['id']) => void;
    }
  | {
      disabled: true;
      onDeselect?: (id: SearchUsersResponse['id']) => void;
    }
);

export const UserSearchResultItems = ({
  disabled,
  onDeselect,
  selectedUsers,
}: UserSearchResultItemsProps) => {
  const { t } = useTranslation(['common']);

  return (
    <ChipContainer>
      {selectedUsers.map((selectedUser) => (
        <Chip
          color="gray"
          fill="strong"
          key={selectedUser.id}
          label={getUserInformation({ t, user: selectedUser })}
          onClose={disabled ? undefined : () => onDeselect(selectedUser.id)}
          shape="rectangular"
          size="xs"
        />
      ))}
    </ChipContainer>
  );
};
